import React from 'react'
import Banner from "../../Components/Banner/Testimony"
import Scroll from "../../Components/ScrollToTop"
import Main from "../../Components/TestimonyMain/TestimonyMain"
function Testimony() {
  return (
    <div>
        <Scroll/>
        <Banner/>
        <Main/>
    </div>
  )
}

export default Testimony
